export const objectEntries = <T, K extends keyof any>(
    o: { [key in K]?: T } | ArrayLike<T>,
): [typeof o extends ArrayLike<T> ? string : K, T][] => {
    return Object.entries(o) as any;
};
